import React from "react";
const InlineError = (props) => {
  return (
    <>
      <div style={{marginLeft:"20px"}} className="text-danger">{props.errorMessage}</div>
    </>
  );
};

export default InlineError;
